export interface Tomo {
  n: string
  cover: string
  title: string
  subtitle: string
  features: string[]
}

export interface Bonus {
  n: string
  cover: string
  title: string
  subtitle: string
}

export const tomos: Tomo[] = [
  {
    n: 'I',
    cover:
      'https://cdn.magicpatterns.com/uploads/6gUjCtKrXfjXBdqLNLVFRL/Vol_1.png',
    title: 'Il sistema professionale del Qi Gong™',
    subtitle: 'Struttura, preparazione e conduzione delle lezioni.',
    features: [
      'Definire l’obiettivo di ogni lezione',
      'Organizzare una struttura chiara dall’inizio alla conclusione',
      'Collegare preparazione, esercizi principali e fase finale',
      'Costruire progressioni comprensibili per gli allievi',
      'Gestire tempi, spazio, ritmo e attenzione del gruppo',
      'Dare consegne più semplici, precise e facili da seguire',
      'Adattare la stessa idea di lezione a contesti diversi',
      'Preparare ogni incontro con maggiore continuità',
    ],
  },
  {
    n: 'II',
    cover:
      'https://cdn.magicpatterns.com/uploads/suhdH4bg69v5783EDftR79/Vol_2.png',
    title: 'Lezioni di Qi Gong pronte da insegnare™',
    subtitle: '20 lezioni strutturate e adattabili.',
    features: [
      'Obiettivo e tema della sessione',
      'Livello indicativo e durata',
      'Ordine delle fasi della lezione',
      'Esercizi e transizioni',
      'Indicazioni da offrire durante la pratica',
      'Varianti per renderla più semplice o più intensa',
      'Come concludere senza interrompere bruscamente il lavoro',
    ],
  },
  {
    n: 'III',
    cover:
      'https://cdn.magicpatterns.com/uploads/9ctBgtZuaPtXefT922Una8/Vol_3.png',
    title: 'Atlante visivo dei movimenti di Qi Gong™',
    subtitle: 'Posizioni, sequenze, indicazioni e correzioni.',
    features: [
      'Osservare le posizioni fondamentali',
      'Comprendere l’ordine delle sequenze',
      'Spiegare le transizioni tra un movimento e l’altro',
      'Riconoscere gli errori più comuni',
      'Formulare correzioni semplici e rispettose',
      'Accompagnare senza sovraccaricare di informazioni',
      'Proporre varianti coerenti con il livello del gruppo',
      'Preparare dimostrazioni più ordinate durante la lezione',
    ],
  },
]

export const bonuses: Bonus[] = [
  {
    n: '1',
    cover:
      'https://cdn.magicpatterns.com/uploads/5NBaA5tdoWaHpV6T2brVMU/Bonus_1.png',
    title: 'Scheda di valutazione del praticante™',
    subtitle: 'Valutazione iniziale e monitoraggio dei progressi.',
  },
  {
    n: '2',
    cover:
      'https://cdn.magicpatterns.com/uploads/558qbT1Yrc2ax2QRsnx92G/Bonus_2.png',
    title: 'Costruttore di lezioni di Qi Gong™',
    subtitle: 'Crea ogni lezione in modo semplice e ordinato.',
  },
  {
    n: '3',
    cover:
      'https://cdn.magicpatterns.com/uploads/oN7WN6SiUcKKYoojWUQtdW/Bonus_3.png',
    title: 'Calendario stagionale della pratica™',
    subtitle: 'Idee e focus per organizzare l’anno.',
  },
  {
    n: '4',
    cover:
      'https://cdn.magicpatterns.com/uploads/qJjLzcsprLsscC6fSBmrmq/Bonus_4.png',
    title: 'Guida all’adattamento delle lezioni™',
    subtitle: 'Come modulare esercizi e sequenze.',
  },
  {
    n: '5',
    cover:
      'https://cdn.magicpatterns.com/uploads/sJSEjAEqWLojqwB1Ft4r68/Bonus_5.png',
    title: 'Schede per allievi e registro dell’insegnante™',
    subtitle: 'Note, presenze e osservazioni.',
  },
]
